module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-19.06a6b8f4.png";